const httpMethods = Object.freeze({
  delete: "DELETE",
  patch: "PATCH",
  post: "POST",
  put: "PUT"
});

export default httpMethods;
